// extracted by mini-css-extract-plugin
export default {"container":"GF-z","modal":"HF-z","dimensions":"IF-z","brandName":"JF-z","productName":"KF-z","labelValue":"LF-z","recipientEmail":"MF-z","recommendedFit":"NF-z","hiddenField":"OF-z"};